import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import DetailContent from './AppDetailContent';
import Disclaimer from './AppDetailDisclaimer';
import DefaultCategoriesHelpful from './DefaultCategoriesHelpful';
import { impressionTrackDetailPage, clickTrack } from '../lib/tracking';
import { FPTI_SELL_PAGE_NAME, HELPFUL } from '../lib/constants';
import getContent from '../lib/dictionaryFetcher';

const AppDetailPage = props => {
  const {
    app,
    history,
    partner,
    experimentation,
    dispatch,
    updatePath
  } = props;

  useEffect(() => {
    impressionTrackDetailPage(props, partner);
  }, []);
  const setApp = (item, opts = {}) => {
    clickTrack(props, {
      page: `${FPTI_SELL_PAGE_NAME}:::${partner}`,
      pgrp: FPTI_SELL_PAGE_NAME,
      link: opts.fptiLink || item
    });

    if (!window.historyStack) {
      window.historyStack = [];
    }

    history.push(`/sell/${item}`);
    dispatch(updatePath(item)); // update path with item
    window.historyStack.push(partner); // keep track of partner history
    window.scrollTo(0, 0); // scroll to top after route change
  };

  const disclaimers = getContent(
      'merchanthub',
      `apps.${partner}.disclaimer`,
      []
    ),
    helpful = get(HELPFUL, partner, ''),
    isHawk = get(app, 'type', '').toLowerCase() === 'business',
    isElmo = get(experimentation, helpful, false),
    shouldDisplay = helpful && isHawk && isElmo;

  return (
    <div id="appdetailpage">
      <div className="appdetailpage-background" />
      <DetailContent partner={partner} {...props} />
      {shouldDisplay && (
        <div className="appdetailpage-addon">
          <DefaultCategoriesHelpful
            partner={partner}
            callback={setApp}
            helpful={helpful}
            category={partner}
          />
        </div>
      )}
      <Disclaimer disclaimers={disclaimers} />
    </div>
  );
};

AppDetailPage.propTypes = {
  app: PropTypes.object,
  dispatch: PropTypes.func,
  updatePath: PropTypes.func,
  tracking: PropTypes.object,
  recordClick: PropTypes.func,
  recordImpression: PropTypes.func,
  partner: PropTypes.string,
  history: PropTypes.object,
  experimentation: PropTypes.object
};

export default AppDetailPage;
